export default __webpack_public_path__ + "static/menu.light-7732bb08625da5ddac09e3f4cd445c2f1ff1df8969fa9355421ac2896fd5e576.png";